var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-display',{staticClass:"p-cms-page",scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("\n    "+_vm._s(_vm.page.cmsPageTitle)+"\n  ")]},proxy:true},{key:"default",fn:function(){return [(_vm.page.cmsSectionItemList)?_c('cms-section-item-list',{attrs:{"section-item-list":_vm.page.cmsSectionItemList}}):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }